import createVueComponent from '../createVueComponent';

const Square = createVueComponent('SquareIcon', [
  [
    'rect',
    { width: '18', height: '18', x: '3', y: '3', rx: '2', key: 'afitv7' },
  ],
]);

export default Square;
